/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

document.addEventListener('DOMContentLoaded', function () {
  const $priceDom = $('#sp_price1')
  const $cPriceDom = $('#sp_price2')
  const $offPriceDom = $('.sp-price-group .sp-p span')
  const $numDom = $('#calcNumber')

  const productData = window.product || []

  /** 获取当前选中的变量 */
  function getCur() {
    const opts = {
      option1: $('#sp-opt-group1 div.active').attr('data-val'),
      option2: $('#sp-opt-group2 div.active').attr('data-val'),
      option3: $('#sp-opt-group3 div.active').attr('data-val'),
    }

    return productData.find(item => {
      return (
        (!opts.option1 || item.option1 == opts.option1) &&
        (!opts.option2 || item.option2 == opts.option2) &&
        (!opts.option3 || item.option3 == opts.option3)
      )
    })
  }

  /** 更新价格显示 */
  function changePrice() {
    const curVariant = getCur()
    if (!curVariant) return

    const num = parseInt($numDom.val()) || 1

    // 识别当前页面使用的小数点符号
    const currentText = $priceDom.text().trim()
    const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/)

    const decimalSeparator = decimalMatch ? decimalMatch[1] : '.'
    const decimalLength = decimalMatch ? decimalMatch[2].length : 0

    // 格式化输出
    const formatValue = cents => {
      let val = ((cents * num) / 100).toFixed(decimalLength)
      if (decimalSeparator === ',') {
        val = val.replace('.', ',')
      }
      return val
    }

    const price = formatValue(curVariant.price)
    const compare = formatValue(curVariant.compare_at_price)

    // 计算折扣
    let offPercent = 0
    if (curVariant.compare_at_price > curVariant.price) {
      offPercent =
        100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100)
    }

    const priceRegex = /\d+(?:[.,]\d+)*/
    const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g

    const updateHTML = ($el, regex, value) => {
      if ($el && $el.length) {
        const text = $el[0].textContent.trim()
        const newHtml = text.replace(regex, value)
        if ($el.html() !== newHtml) {
          $el.html(newHtml)
        }
      }
    }

    updateHTML($priceDom, priceRegex, price)
    updateHTML($cPriceDom, priceRegex, compare)
    updateHTML($offPriceDom, offRegex, offPercent)
  }

  // 绑定选项点击事件
  $(document).on('click', '.sp-option', function () {
    setTimeout(changePrice, 10)
  })

  $('.sp_buy_now').click(function () {
    let num = $numDom.val()
    let id = getCur().id
    window.location.href = '/cart/' + id + ':' + num
  })

  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-p1.png',
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-p2.png',
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-p3.png',

    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-b1.png',
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-b2.png',
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-b3.png',
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-b4.png',
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-b5.png',
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-b6.png',
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-c1.png',
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-c2.png',
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-c3.png',
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-c4.png',
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-c5.png',
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-c6.png',
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-c7.png',
    'https://cdn.shopify.com/s/files/1/0759/5058/8158/files/202512252-c8.png',
  ]

  let sp_price1 = 28.99
  let sp_price2 = 57.98

  function calcTotal(price, num) {
    let result = Number(price) * Number(num)
    return result.toFixed(2)
  }
  $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    changePrice()
  })
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice()
  })

  $('.sp-option').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')

    let colorOptions = $('.sp-opt-group1 .sp-option.active').index()
    //   let numOptions = $(".sp-opt-group2 .sp-option.active").index();
    let _index = colorOptions
    // $("#sptext1").text(sptextList[colorOptions]);
    // let _index = colorOptions;
    _swiper.slideToLoop(_index)
  })

  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)

    // const randomMinutes = 30; // 25到35分钟
    // const currentTime = new Date();
    // endTimeG = new Date(currentTime.getTime() + randomMinutes * 60 * 1000);
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  new Swiper('.sp-swiper-fade-top', {
    spaceBetween: 10,
    effect: 'fade',
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  })

  // // 按钮轮播
  new Swiper('.sp-btn-loop', {
    spaceBetween: 10,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      reverseDirection: true,
    },
    loop: true,
  })

  new Swiper('.sp-swiper7', {
    autoplay: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: '.sp-pagination',
      clickable: true,
    },
  })

  new Swiper('.sp-swiper5', {
    autoplay: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
  })

  new Swiper('.sp-swiper1', {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    speed: 300,
    effect: 'slide',
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
  })

  new Swiper('.sp-swiper2', {
    autoplay: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: '.sp-part2 .sp-item2 .sp-pagination',
      clickable: true,
    },
  })

  // new Swiper(".sp-swiper2", {
  //   spaceBetween: 16,
  //   autoplay: true,
  //   autoplay: {
  //     disableOnInteraction: false,
  //     delay: 0,
  //   },
  //   loop: true,
  //   speed: 6000,
  //   slidesPerView: "auto",
  // });

  // 走马灯初始化函数
  function initScroll1() {
    // 只在移动端且元素可见时初始化
    if (jQuery('.sp_mobile').is(':visible') && jQuery('.sp-scroll1').length) {
      jQuery('.sp-scroll1').slide({
        mainCell: '.nav-imgs',
        autoPlay: true,
        effect: 'leftMarquee',
        interTime: 12,
        vis: 1,
        scroll: 1,
      })
    }
  }

  initScroll1()

  function initScroll2() {
    // 只在移动端且元素可见时初始化
    if (jQuery('.sp_mobile').is(':visible') && jQuery('.sp-scroll2').length) {
      jQuery('.sp-scroll2').slide({
        mainCell: '.nav-imgs',
        autoPlay: true,
        effect: 'leftMarquee',
        interTime: 12,
        vis: 1,
        scroll: 1,
      })
    }
  }

  initScroll2()

  function initScroll6_l() {
    // 只在移动端且元素可见时初始化
    if (jQuery('.sp_mobile').is(':visible') && jQuery('.sp-scroll6-l').length) {
      jQuery('.sp-scroll6-l').slide({
        mainCell: '.nav-imgs-l',
        autoPlay: true,
        effect: 'leftMarquee',
        interTime: 12,
        vis: 1,
        scroll: 1,
      })
    }
  }

  initScroll6_l()

  // 使用 matchMedia 监听媒体查询变化（控制台切换设备模式时触发）
  const mobileMediaQuery = window.matchMedia('(max-width: 1080px)')
  mobileMediaQuery.addEventListener('change', function (e) {
    if (e.matches) {
      // 切换到移动端时，延迟初始化走马灯
      setTimeout(function () {
        jQuery('.sp-scroll2').html(jQuery('.sp-scroll2').html()) // 重置 DOM
        initScroll2()
        jQuery('.sp-scroll6-l').html(jQuery('.sp-scroll6-l').html())
        initScroll6_l()
      }, 100)
    }
  })

  // 监听窗口 resize
  let resizeTimer
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(function () {
      if (jQuery('.sp_mobile').is(':visible')) {
        jQuery('.sp-scroll2').html(jQuery('.sp-scroll2').html())
        initScroll2()
        jQuery('.sp-scroll6-l').html(jQuery('.sp-scroll6-l').html())
        initScroll6_l()
      }
    }, 200)
  })

  let _swiper = new Swiper('.sp-swiper-pro', {
    speed: 1,
    spaceBetween: 0,
  })

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
      } else {
        const scale = document.body.clientWidth / 1920
        $('#root').css('zoom', scale)
      }

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
              } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
              }
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为

        // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $('.sp-nav').height()
            : targetElement.offsetTop
        let sptop = document.body.clientWidth <= 1080 ? 60 : 90

        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            sptop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        })
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }

    // 平整的左右滑动轮播
    var carouselSwiper = new Swiper('#carousel .swiper', {
      grabCursor: true,
      centeredSlides: false,
      slidesPerView: 'auto',
      spaceBetween: 30,
      loop: true,
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        reverseDirection: false,
      },
      freeMode: {
        enabled: true,
        momentum: false,
      },
      speed: 5000,
      on: {
        touchEnd: function () {
          var swiper = this
          setTimeout(function () {
            swiper.autoplay.stop()
            swiper.autoplay.start()
          }, 50)
        },
        slideChangeTransitionEnd: function () {
          var swiper = this
          setTimeout(function () {
            if (!swiper.autoplay.running) {
              swiper.autoplay.stop()
              swiper.autoplay.start()
            }
          }, 50)
        },
      },
    })

    // 定期检查并重启自动播放
    setInterval(function () {
      if (carouselSwiper && !carouselSwiper.autoplay.running) {
        carouselSwiper.autoplay.start()
      }
    }, 1000)
  }

  mainRender()

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // 使用Intersection Observer监听元素进入视口
  document.addEventListener('DOMContentLoaded', function () {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible')
          }
        })
      },
      {
        threshold: 0.1, // 当10%的元素可见时触发
        rootMargin: '0px 0px -50px 0px', // 提前50px触发
      }
    )

    // 观察所有.sp-item元素
    document.querySelectorAll('.sp-identifier .sp-item').forEach(item => {
      observer.observe(item)
    })
  })

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  $('.size-btn').click(function () {
    $('.sp-mask2').show()
    $('.sp-mask2 .sp-content').show()
  })

  $('.sp-mask2 .sp-close').click(function () {
    $('.sp-mask2').hide()
    $('.sp-mask2 .sp-content').hide()
  })

  // 菜单
  $('.sp-menu-btn').click(function (e) {
    $('.sp-menu-mask').show()
  })

  $('.sp-menu-mask').click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $('.sp-menu-mask').hide()
    // }
  })

  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $('.sp_header').height() * $('div#root').css('zoom')
  ) {
    $('.sp_header-wrap').addClass('sp-fixed')
  } else {
    $('.sp_header-wrap').removeClass('sp-fixed')
  }

  let spTimer = null
  let spHasShown = false // 防止重复显示

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $('.sp_header').height() * $('div#root').css('zoom')
    ) {
      $('.sp_header-wrap').addClass('sp-fixed')
    } else {
      $('.sp_header-wrap').removeClass('sp-fixed')
    }

    // 滚动添加底部
    if (spHasShown) return // 已经显示就不再触发

    // 如果没有定时器，则开始计时
    if (!spTimer && $(window).scrollTop() > 800) {
      spTimer = setTimeout(function () {
        document.querySelector('.sp-btn-style2').style.display = 'flex'
        spHasShown = true // 标记为已显示
      }, 3000)
    }
  })

  $(document).on('click', '.sp_buy_now', function () {
    console.log('xxx111')
  })

  let initNum = 0
  $(document).on('click', '.sp_add_cart', function () {
    // 购物车加购动效

    $(this).children('img').addClass('on')
    $('.sp-cart .num').show()
    setTimeout(function () {
      $(' .cart-btn').children('img').removeClass('on')
    }, 500)
    $(' .sp-cart').addClass('on')
    setTimeout(function () {
      $('.sp-cart').removeClass('on')
    }, 500)

    let spNum = $('.sp_product_part #calcNumber')[0].value
    initNum += Number(spNum)

    // $("#calcNumber").val(1);

    /* $(".cardNum").each(function () {
        $(this).html(initNum);
      }); */

    const data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          $('.cardNum').html(result.item_count)
          $('.cardNum').removeClass('sp-gray')
        })
      },
      dataType: 'json',
    })

    // handleAddToCart(initNum);

    var imgs = $('.sp_product_part .swiper-slide-active').find('img')
    // var imgs = $(".sp_product_part .sp-img-p.active");

    imgs.each(function () {
      var $img = $(this)
      var flyer = $img[0].cloneNode(true)
      flyer.classList.add('sp_clone')

      $('.sp_product_part').append(flyer)
      $(flyer).css({
        width: $img[0].width,
        height: $img[0].height,
        background: '#e7e9ef',
        position: 'fixed',

        top: $img[0].offsetTop,
        left: $img.offset().left,
        'z-index': 99,
      })
      let finish
      if (document.body.clientWidth <= 1080) {
        finish = $('.sp-btn-style2 .sp-cart')

        $(flyer).animate(
          {
            top: $('.sp-btn-style2')[0].offsetTop,
            left:
              $('.sp-btn-style2  .sp-area2')[0].offsetLeft +
              finish.width() / 2 +
              378,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      } else {
        finish = $('.sp_pc .sp-cart')
        $(flyer).animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      }
    })
  })

  // 滚动添加底部（首屏不添加，滚动后出现）
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 0) {
      if (
        $(window).scrollTop() >
        $('.sp-part1').height() * $('div#root').css('zoom') -
          $('.sp-part1 .sp-content').height() * $('div#root').css('zoom')
      ) {
        $('.sp-btn-style2').addClass('sp-fixed-bottom')
      } else {
        $('.sp-btn-style2').removeClass('sp-fixed-bottom')
      }
    } else {
      $('.sp-btn-style2').removeClass('sp-fixed-bottom')
    }
  })

  // 问答
  $('.sp-qa1-faq-question').on('click', function () {
    var $currentItem = $(this).parent('.sp-qa1-faq-item') // 当前点击的父级
    var $answer = $(this).next('.sp-qa1-faq-answer') // 当前的答案部分
    var $icon = $(this).find('.sp-qa1-faq-icon') // 当前的图标

    // 如果当前已经是打开的，则关闭它
    if ($currentItem.hasClass('active')) {
      $answer.slideUp()
      $currentItem.removeClass('active')
      $icon.removeClass('fa-minus').addClass('fa-plus')
    } else {
      // 如果当前是关闭的：

      // 1. 先关闭所有其他的项 (互斥效果)
      $('.sp-qa1-faq-item').removeClass('active')
      $('.sp-qa1-faq-answer').slideUp()
      $('.sp-qa1-faq-icon').removeClass('fa-minus').addClass('fa-plus')

      // 2. 展开当前项
      $currentItem.addClass('active')
      $answer.slideDown()
      $icon.removeClass('fa-plus').addClass('fa-minus')
    }
  })

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })

            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually3)
  }
})
